import { Component, EventEmitter } from '@angular/core';


@Component({
    selector: 'app-dialog-overlay',
    templateUrl: './dialog-overlay.component.html',
    styleUrls: ['./dialog-overlay.component.scss'],
    standalone: false
})
export class DialogOverlayComponent {
    onOk: EventEmitter<any> = new EventEmitter();
    onCancel: EventEmitter<any> = new EventEmitter();
    message: string;
    isDialogVisible = false;
    className = '';

    okClicked(): void {
        this.onOk.emit();
    }

    cancelClicked(): void {
        this.onCancel.emit();
    }

    show(message, className?: string): void {
        this.message = message;
        this.isDialogVisible = true;
        this.className = className;
    }

    hide(): void {
        this.isDialogVisible = false;
    }
}
